import { DeclarationDrBase } from './declaration-dr.base.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationSV12 extends DeclarationDrBase {
    static jsonMap = {
        ...DeclarationDrBase.jsonMap,
        s_recolte: { key: 's_recolte' },
        qte_achat_vf: { key: 'qte_achat_vf' },
        vol_achat_m: { key: 'vol_achat_m' },
        vol_issu_vf: { key: 'vol_issu_vf' },
        vol_issu_m: { key: 'vol_issu_m' },
        details: { key: 'list', converter: new (ArrayClassConverterFactory.build(DeclarationSV12))(), optional: true, default: () => [] }
    };

    s_recolte: number;
    qte_achat_vf: number;
    vol_achat_m: number;
    vol_issu_vf: number;
    vol_issu_m: number;
    details: DeclarationSV12[];
}
